import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { MoonStars, ChartLineUp } from '@phosphor-icons/react';
import { useI18n } from '../contexts/I18nContext';
import { NightSummary } from '../components/reports/NightSummary';
import { WeekTrend } from '../components/reports/WeekTrend';

// Report registry — add future reports here.
const REPORTS = [
  { id: 'night', icon: MoonStars, titleKey: 'rep_night_title', descKey: 'rep_night_desc', Component: NightSummary },
  { id: 'week', icon: ChartLineUp, titleKey: 'wt_title', descKey: 'wt_desc', Component: WeekTrend },
];

export default function Reports() {
  const { t } = useI18n();
  const [params, setParams] = useSearchParams();
  const active = REPORTS.find((r) => r.id === params.get('r')) || REPORTS[0];

  return (
    <div className="space-y-8 animate-fade-up" data-testid="reports-page">
      <header>
        <div className="text-xs uppercase tracking-[0.2em] text-sage-500 font-semibold mb-3">{t('nav_reports')}</div>
        <h1 className="font-heading text-4xl sm:text-5xl text-ink leading-none">{t(active.titleKey)}</h1>
        <p className="text-ink-soft mt-3 max-w-xl">{t(active.descKey)}</p>
      </header>
      <nav className="flex gap-2 flex-wrap" data-testid="reports-tabs">
        {REPORTS.map((r) => (
          <button
            key={r.id}
            type="button"
            onClick={() => setParams({ r: r.id })}
            data-testid={`reports-tab-${r.id}`}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm border transition-colors ${
              r.id === active.id ? 'bg-sage text-white border-sage' : 'bg-white text-ink-soft border-stone_line hover:bg-bg-alt'
            }`}
          >
            <r.icon size={16} weight="duotone" /> {t(r.titleKey)}
          </button>
        ))}
      </nav>
      <active.Component />
    </div>
  );
}
